import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import "./i18n";
import { Amplify } from "aws-amplify";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

const {
  REACT_APP_IDENTITY_POOL_ID,
  REACT_APP_REGION,
  REACT_APP_USER_POOL_ID,
  REACT_APP_USER_CLIENT_ID,
} = process.env;
Amplify.configure({
  Auth: {
    identityPoolId: REACT_APP_IDENTITY_POOL_ID, //REQUIRED - Amazon Cognito Identity Pool ID

    region: REACT_APP_REGION, // REQUIRED - Amazon Cognito Region

    userPoolId: REACT_APP_USER_POOL_ID, //OPTIONAL - Amazon Cognito User Pool ID

    userPoolWebClientId: REACT_APP_USER_CLIENT_ID, //OPTIONAL - Amazon Cognito Web Client ID

    authenticationFlowType: "USER_PASSWORD_AUTH",

    usernameAttributes: "email",
  },
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
